<template lang="html">
  <b-container class="partner-page">
    <div class="row " v-if="$store.user.type == 'admin'">


      <div class="col-md-12 center-text title" >
        Carica Prodotti
      </div>
      <div class="col-md-12 center-text subtitle" >
        In questa sezione potrai creare e assegnare prodotti ad un utente
      </div>
      <div class="col-md-12 center-text subtitle" >
        Scegli un utente, filtra per azienda per ottenere una lista di utenti più precisa
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 riga-bottone-aggiungi" >
        <div class="button-container">
          <b-button class="add-button" @click="form={user_id:filters.user_id}" variant="primary">
            Aggiungi un prodotto
          </b-button>
        </div>
      </div>
      <div class="col-md-6">
        <div style="display:flex;justify-content:center;align-items:center;padding-top: 40px;" v-if="$store.user.type == 'admin' && current_user_data">
          {{current_user_data.full_name}}
        </div>
      </div>
    </div>

    <div class="row" v-if="$store.user.type == 'admin'">
      <div class="col-md-12">
        <div class="filter-row">
          <div class="company-filter">
            <div class="center-text subtitle">
              Cerca un azienda
            </div>
            <div class="company-input">
              <b-form-input v-model="search_value" placeholder="Filtra per azienda"></b-form-input>
              <button class="btn btn-primary" @click="searchUsers"  >Cerca</button>
            </div>
          </div>
          <div class="user-filter" v-if="users">
            <div class="center-text subtitle">
              Scegli l'utente a cui aggiungere il prodotto
            </div>
            <b-select v-model="filters.user_id">
              <option v-for="u in users" :key="u.id" :value="u.id">{{ u.company }} ({{ u.name }} {{u.surname}} ){{u.type}}</option>
            </b-select>
          </div>
        </div>
      </div>
    </div>





      <div class="table table-responsive table-hover">
        <table class="w-100">
          <thead>
            <tr class="product-table-header">
              <th></th>
              <th>Nome</th>
              <th>Codice Prodotto</th>

              <th>Lato corto</th>
              <th>Lato lungo</th>
              <th>Disponibilità</th>
              <th>Quantità</th>
              <!-- <th>Scandeza</th> -->
            </tr>
          </thead>
          <tbody>
            <tr v-if="!products">
              <td colspan="100%">
                Caricamento...
              </td>
            </tr>
            <tr v-else-if="!products.total">
              <td colspan="100%">
                Nessun Prodotto
              </td>
            </tr>
            <tr class="pointer" v-for="product in (products || {}).data" :key="product.id" @click="form = _.cloneDeep(product)">
              <td>
                <img v-if="product.images.length" :src="$url(product.images[0].thumb.sm)" style="width:3rem"/>
              </td>
              <td v-text="product.name"></td>
              <td>
                <span v-if="product.is_varie" class="text-info">
                  Varie
                </span>
                <span v-else-if="product.product_type.is_std" class="text-success">
                  {{ product.product_type.code }}
                </span>
                <span v-else class="text-warning">Fuori standard</span>
                <!-- <span :class="product.product_type.is_std ? 'text-success' : 'text-warning'">
                  {{ product.product_type.code }}
                </span> -->
              </td>
              <td v-text="product.product_type && product.product_type.side_a"></td>
              <td v-text="product.product_type && product.product_type.side_b"></td>

              <td v-if="product.always_available" class="green"> Sempre disponibile </td>
              <td v-else-if="product.time_to_expiry >= 14 " class="green"> {{parseInt(product.time_to_expiry)}} gg </td>
              <td class="yellow" v-else-if="product.time_to_expiry < 14 && product.time_to_expiry > 7">{{parseInt(product.time_to_expiry)}} gg</td>
              <td class="red" v-else>{{parseInt(product.time_to_expiry)}} gg</td>
              <td v-text="product.quantity"></td>

              <td class="text-right">
                <b-icon class="text-info ml-2" icon="files" @click.stop="cloneProduct(product)" v-b-tooltip.hover title="Clona"/>
                <b-icon class="text-danger ml-2" icon="trash" @click.stop="deleteProduct(product.id)" v-b-tooltip.hover title="Elimina"/>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <b-pagination v-if="products && products.last_page > 1"
        :total-rows="products.total"
        :per-page="products.per_page"
        first-text="<<"
        prev-text="<"
        next-text=">"
        last-text=">>"
        v-model="page"
        />






    <b-modal :visible="!!form" @hidden="form = null" hide-footer hide-header size="lg">
      <template >
        <product-form v-if="form" :form="form" @saved="refreshProducts()" @close="form=null"/>

      </template>
      <!-- <template v-else lang="html">
        <ProductFormSimplified v-if="form" :form="form" @saved="refreshProducts()" @close="form=null"/>

      </template> -->




    </b-modal>
  </b-container>
</template>

<script>
import ProductForm from '@/components/product-form'
// import ProductFormSimplified from '@/components/product-form-simplified'

export default {
  components: {
    ProductForm,
    // ProductFormSimplified
  },

  data() {
    return {
      products: null,
      page: 1,
      form: null,
      users: null,
      search_value: null,
      filters: {
        user_id: this.$store.user.id,
      },
      current_user_data: null,
    }
  },

  created() {
    this.refreshProducts()
    if (this.$store.user.type == 'admin') {
      // this.refreshUsers()
      this.refreshPartners()
      this.get_current_user_data()
    }

  },
  methods: {
    superClone(x){
      return JSON.parse(JSON.stringify(x))
    },
    cloneProduct(p) {
      let form = this.superClone(p)
      delete(form.id)
      if(!p.is_varie){

        if (!form.product_type.is_std) {
          delete(form.product_type_id)
          delete(form.product_type.id)
        }
      }
      this.form = form
    },
    refreshProducts() {
      let params = {
        user_id: this.filters.user_id,
        page: this.page,
      }
      this.$http.get('products', {
        params
      }).then(res => {
        this.products = res.data
      })
    },
    refreshUsers() {
      this.$http.get('users').then(res => {
        this.users = res.data
      })
    },


    get_current_user_data(){
      let params = {
        user_id: this.filters.user_id,
      }
      this.$http.get('get_user',
        {params}
      ).then(res => {
        this.current_user_data = res.data
      })
    },



    refreshPartners(){
      console.log("aggiornamento partners")
      let params = {
        userType: "partner",
      }
      this.$http.get('users' , {
        params
      }).then(res => {
        this.users = res.data
      })
    },


    deleteProduct(id) {
      this.$bvModal.msgBoxConfirm('Sei sicuro ?')
        .then(value => {
          if(value){
            this.$http.delete('products/' + id).then(() => {
              this.refreshProducts()
            })
          }
        })
        .catch(err => {
          // An error occurred
          console.log(err)
        })
    },
    searchUsers(){

      let params= {
        searched_value: this.search_value,
        userType: "partner",
      }
      this.$http.get('users', {
        params
      }).then(res => {
        this.users = res.data
      })
    },
  },
  watch: {
    page() {
      this.refreshProducts()
    },
    filters: {
      deep: true,
      handler() {
        this.page = 1
        this.refreshProducts()
        this.get_current_user_data()
      }
    }
  }


}
</script>

<style lang="scss">
.riga-bottone-aggiungi{
  padding-top:40px;
  padding-bottom: 30px;
  width:100%;
}
.table.table-responsive.table-hover{
  padding-bottom:20px;
  min-height:100px;
}
.center-text{
  width: 100%;
  text-align: center;
}
.title{
  font-size:30px;
}
.subtitle{
  font-size:18px;
}
.filter-row{
  display: flex;
  widht:100%;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  padding-top:30px;
  padding-bottom:30px;
}
.company-filter{
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction:column;
  width:100%;
  padding-right:30px;
}
.company-input{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  width:100%;
}
.user-filter{
  width:100%;
  padding-left:30px;
}
.button-container{
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;
  width:100%;
}
.add-button{
  font-size:20px;
  padding-left:40px;
  padding-right:40px;
}
.pallino{
  width:20px;
  height:20px;
  background-color:blue;
}
.green{
  background-color:#81bb5d;
}
.yellow{
  background-color:#fbad5d;
}
.red{
  background-color:#eb5d5d;
}

</style>
